import styled, {css} from "styled-components";

interface IGroupFiltersListGroupItemsContainerBoxProps {
    isOpen?: boolean;
}

export const GroupFiltersListGroupFiltersContainerBox = styled.div<IGroupFiltersListGroupItemsContainerBoxProps>`
  display: block;
  transition: all 0.3s ease-in;
  max-height: 0;
  overflow: hidden;
  
  ${({isOpen}) => isOpen && css` max-height: 100vh `};  
`;